import './styles/tailwind.css';
import './styles/main.scss';

import App from './components/App';
import React from 'react';
import { render } from 'react-dom';

render(<App />, document.getElementById('root'));
